import { connect } from 'react-redux';

import ContentPanelIframe from './ContentPanelIframe.view';
import groupSelectors from '../../../redux/reduxStore/group';
import sessionSelectors from '../../../redux/reduxStore/session';
import navigationActions from '../../../redux/actions/navigation';
import routeNames from '../../../lib/routeNames';
import listLocaleSelector from '../../../redux/reduxStore/lists/listLocale';
import userSelector from '../../../redux/reduxStore/user';

const mapStateToProps = (state) => {
  const localeId = userSelector.getLocaleId(state);
  const localeData = listLocaleSelector.getLocale(state, localeId);
  const languageCode = localeData.language_code;
  const group = groupSelectors.getActiveGroup(state);
  let groupName = '';
  if (group.name && group.name.i18n[languageCode]) {
    groupName = group.name.i18n[languageCode];
  } else if (group.name && group.name.default) {
    groupName = group.name.default;
  }
  return {
    groupName,
    isLoggedIn: sessionSelectors.isLoggedIn(),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    goLogin: () => {
      dispatch(navigationActions.goTo(routeNames.loginEmail()));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContentPanelIframe);
